import type { FC } from "react";
import { Autocomplete } from "./autocomplete/Autocomplete";
import type { ICategory } from "app/common/services/categoryService.types";
import type { IDomains } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";
import { ESelectDomainOptions } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";
import { Table } from "app/pages/industry-analysis/market-builder/tabs/industry/table/Table";
import { NoData } from "pro-features/components/NoData/src/NoData";
import type { IIndustryState } from "app/pages/industry-analysis/market-builder/tabs/types";
import { InitialStateIcon, TableContainer, Wrapper } from "app/pages/industry-analysis/market-builder/tabs/common/styled";
import { allTrackers } from "app/services/track/track";
import type { ICountryObject } from "app/services/CountryService";

interface IIndustry {
    selectedDomains: IDomains;
    addDomains: (domains: IDomains, shouldSyncFavicons?: boolean, section?: ESelectDomainOptions) => void;
    selectedCountry: ICountryObject;
    industryTabState: IIndustryState;
    setIndustryTabState: (industryTabState: IIndustryState) => void;
}

const Industry: FC<IIndustry> = (props) => {
    const { selectedDomains = [], addDomains, selectedCountry, industryTabState, setIndustryTabState } = props;
    const { selectedIndustry } = industryTabState;
    const setSelectedIndustry = (selectedIndustry: ICategory) => {
        allTrackers.trackEvent("Button", "click", `By industry/chooseIndustry/${selectedIndustry.id}`);
        setIndustryTabState({ ...industryTabState, selectedIndustry });
    };
    const onIndustryClick = (selectedValue) => {
        setSelectedIndustry(selectedValue);
    };

    const onAddDomains = (domains) => {
        allTrackers.trackEvent("Button", "click", `By industry/addToList/${domains.length}`);
        addDomains(domains, false, ESelectDomainOptions.INDUSTRY);
    };

    return (
        <Wrapper>
            <Autocomplete
                selectedIndustry={selectedIndustry}
                onChangeSelectedIndustry={onIndustryClick}
            />
            <TableContainer>
                {selectedIndustry ? (
                    <Table
                        selectedDomains={selectedDomains}
                        selectedCountry={selectedCountry}
                        selectedIndustry={selectedIndustry}
                        addDomains={onAddDomains}
                        industryTabState={industryTabState}
                        setIndustryTabState={setIndustryTabState}
                    />
                ) : (
                    <NoData
                        title={null}
                        subtitle={"industry.research.market.builder.no.data.subtitle"}
                        SvgImage={() => <InitialStateIcon iconName={"company-empty-suggestions"} />}
                    />
                )}
            </TableContainer>
        </Wrapper>
    );
};

export default Industry;
